import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BookingProvider } from './context/BookingContext';
import Header from './components/Header';
import SearchPage from './pages/SearchPage';
import ResultsPage from './pages/ResultsPage';
import BookingPage from './pages/BookingPage';
import PrintPage from './pages/PrintPage';
import FleetPage from './pages/FleetPage';
import AdditionalsPage from './pages/AdditionalsPage';
import LocationsPage from './pages/LocationsPage';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { initClarity } from './services/clarity';
import { initMetaPixel } from './services/metaPixel';
import './App.css';

function App() {
  useEffect(() => {
    console.log("ENV:", process.env.NODE_ENV);
    console.log("API:", process.env.REACT_APP_API_URL);
    // Inicializar Microsoft Clarity
    initClarity();
    // Inicializar Meta Pixel
    initMetaPixel();
  }, []);

  return (
    <BookingProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<SearchPage />} />
            <Route path="/buscar" element={<ResultsPage />} />
            <Route path="/reserva" element={<BookingPage />} />
            <Route path="/imprimir" element={<PrintPage />} />
            <Route path="/flota" element={<FleetPage />} />
            <Route path="/adicionales" element={<AdditionalsPage />} />
            <Route path="/ubicaciones" element={<LocationsPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/analytics" element={
              <ProtectedRoute>
                <AnalyticsDashboard />
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </BookingProvider>
  );
}

export default App;
